var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlflowJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_11639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 4.27218C23.3016 -1.19948 12.6548 -0.123643 6.08775 6.8018C-0.479301 13.7273 -0.988428 24.4161 4.89066 31.9344L10.7604 27.6259C7.84676 24.0115 7.25498 19.0499 9.23676 14.8515C11.2185 10.6532 15.4253 7.95666 20.0675 7.9089L19.9286 12.4953L31.1214 4.27218Z",
    fill: "#43C9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4623 8.55319C35.2678 8.28449 35.0639 8.02043 34.8555 7.76562L29.2035 11.9351C32.3942 15.4661 33.222 20.5382 31.3195 24.9005C29.4171 29.2627 25.1367 32.1069 20.378 32.171L20.5171 27.5893L9.19922 35.9281C16.9555 41.1512 27.3435 40.0443 33.8251 33.3045C40.3068 26.5646 41.0073 16.1414 35.4855 8.59489L35.4623 8.55319Z",
    fill: "#0194E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_11639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlflowJob);
export default __webpack_public_path__ + "static/media/mlflow-job.a08ba6c466eab24ea6fdd87335773d0d.svg";
export { ForwardRef as ReactComponent };